import { ValidationError } from 'common/errors';
// eslint-disable-next-line import/no-restricted-paths
import orchInitiateIdValidation from 'orch-communicator/external/initiate-identity-validation';
import { InitiateIdentityValidationPayload } from 'types/vsb-sdk/initiate-identity-validation';
import pushEvents from './push-events';

export default async function initiateIdentityValidation(): Promise<
  InitiateIdentityValidationPayload | ValidationError
> {
  const response = orchInitiateIdValidation();

  if ('error' in response) {
    /* START GENAI@GHCOPILOT */
    const step = `VSB_INITIATE_IDENTITY_API_FAILED_RESPONSE`;
    pushEvents({
      E: step,
      CO: 'VSB_SDK_V2'
    });

    /* END GENAI@GHCOPILOT */
    throw response;
  }

  /* START GENAI@GHCOPILOT */
  const step = `VSB_INITIATE_IDENTITY_API_SUCCESS_RESPONSE`;
  pushEvents({
    E: step,
    CO: 'VSB_SDK_V2'
  });
  /* END GENAI@GHCOPILOT */

  return response;
}
